// src/context/ModalContext.tsx
'use client';

import React, { createContext, useContext, useState } from 'react';
import AddActivityModal from "@/components/modals/AddActivityModal";
import LogMacrosModal from "@/components/modals/LogMacrosModal";
import UpdateGoalModal from "@/components/modals/UpdateGoalModal";

interface ModalContextType {
  openAddActivity: (onSuccess?: () => void) => void;
  openLogFood: (onSuccess?: () => void) => void;
  openUpdateGoal: (onSuccess?: () => void) => void;
}

const ModalContext = createContext<ModalContextType | undefined>(undefined);

export function ModalProvider({ children }: { children: React.ReactNode }) {
  const [showAddActivity, setShowAddActivity] = useState(false);
  const [showLogFood, setShowLogFood] = useState(false);
  const [showUpdateGoal, setShowUpdateGoal] = useState(false);
  
  const [onActivitySuccess, setOnActivitySuccess] = useState<(() => void) | undefined>();
  const [onFoodSuccess, setOnFoodSuccess] = useState<(() => void) | undefined>();
  const [onGoalSuccess, setOnGoalSuccess] = useState<(() => void) | undefined>();

  const openAddActivity = (onSuccess?: () => void) => {
    setOnActivitySuccess(() => onSuccess);
    setShowAddActivity(true);
  };
  const openLogFood = (onSuccess?: () => void) => {
    setOnFoodSuccess(() => onSuccess);
    setShowLogFood(true);
  };
  const openUpdateGoal = (onSuccess?: () => void) => {
    setOnGoalSuccess(() => onSuccess);
    setShowUpdateGoal(true);
  };

  return (
    <ModalContext.Provider value={{ openAddActivity, openLogFood, openUpdateGoal }}>
      {children}
      <AddActivityModal open={showAddActivity} onClose={() => setShowAddActivity(false)} onSuccess={() => { setShowAddActivity(false); onActivitySuccess?.(); }} />
      <LogMacrosModal open={showLogFood} onClose={() => setShowLogFood(false)} onSuccess={() => { setShowLogFood(false); onFoodSuccess?.(); }} />
      <UpdateGoalModal open={showUpdateGoal} onClose={() => setShowUpdateGoal(false)} onSuccess={() => { setShowUpdateGoal(false); onGoalSuccess?.(); }} />
    </ModalContext.Provider>
  );
}

export const useModals = () => {
  const context = useContext(ModalContext);
  if (!context) throw new Error("useModals must be used within ModalProvider");
  return context;
};
